/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BaseFieldGroup.vue?vue&type=template&id=0eb16df2"
import script from "./BaseFieldGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseFieldGroup.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports